import { useEffect, useState, useRef } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store";
import { getProductsStart, updateOnlyProductsStart } from "redux/sellers";
import { addToWishListStart, removeFromWishListStart } from "redux/wishlist";
import {
  Box,
  Modal,
  Tooltip,
  Typography,
  TextField,
  Pagination,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Grid,
  MenuItem,
  Button,
} from "@mui/material";
import { titelize } from "utils/titelize";
import CopyToClipboard from "react-copy-to-clipboard";
import snack from "components/wrapper/snack";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { getReviewBySellerId } from "redux/rating";
import Drawer from "@mui/material/Drawer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  ClearButton,
  FilterContainer,
  FilterLabel,
  MobileViewFilterWrapper,
  CardContainer,
} from "./styledComponents";
import { Search } from "@material-ui/icons";
import { checkIsValidArray } from "utils";
import React from "react";
import Popper from "@mui/material/Popper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Paper from "@mui/material/Paper";
import ShopBanner from "./ShopBanner";
import ShopMetaTags from "../ShopList/ShopMetaTags";
import styled from "styled-components";
import {
  followSeller,
  unfollowSeller,
  getFollowingStatus,
} from "../../../../api/followApi";
import SingleProductLayout from "./SingleProductView";
import { setProductFilter } from "redux/productFilter";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { getAuthorsStart } from "redux/authors";

// background-color: ${({ isFollowed }) => (isFollowed ? '#ffa41c' : '#f0c14b')};
// border: 1px solid ${({ isFollowed }) => (isFollowed ? '#ffa41c' : '#a88734 #9c7e31 #846a29')};
const FollowButton = styled.button<{ isFollowed: boolean; disabled: boolean }>`
  background-color: #000;
  color: #fff;
  margintop: 15px;
  padding: 5px 10px;
  font-size: 10px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  border-radius: 3px;
  text-align: center;
  &:hover {
    background-color: ${({ isFollowed }) =>
      isFollowed ? "#e78a15" : "#ddb347"};
  }
`;

const ShopDetails = () => {
  const location: any = useLocation();
  const params = useParams<any>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [id, setId] = useState(null);
  const [page, setPage] = useState(1);
  const [tabValue, setTabValue] = useState("1");
  const [shareProductDetails, setShareProductDetails] = useState({
    id: "",
    title: "",
  });
  const isBookSeller = params?.id === "0592de2a-815c-4929-a521-82301b246cce";
  const [isLoading, setIsLoading] = useState(false);
  const [isFollowing, setIsFollowing] = useState(false);
  const [shareModelOpen, setShareModelOpen] = useState(false);
  const [sellerBrandData, setSellerBrandData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState("");
  // const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  // useEffect(() => {
  //   if (debounceTimeout.current) {
  //     clearTimeout(debounceTimeout.current);
  //   }
  //   debounceTimeout.current = setTimeout(() => {
  //     if (currentFilterState.sellerId !== null) {
  //       handleInternalTextSearch(searchValue);
  //     }
  //   }, 600); // 350ms debounce
  //   return () => {
  //     if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
  //   };
  // }, [searchValue]);

  const [filteredData, setFilteredData] = useState<{
    brand: any[];
    categories: any[];
  }>({ brand: [], categories: [] });
  const [openDropdown, setOpenDropdown] = useState<any>({});
  const [anchorEl, setAnchorEl] = useState<any>({});

  const [searchField, setSearchField] = useState("title"); // default to title

  const [filter, setfilter] = useState<boolean>(false);

  const [smallScreenFilter, setSmallScreenFilter] = useState<string | false>(
    false
  );
  const currentFilterState = useSelector(
    (state: RootState) => state.productFilter
  );

  const syncedFilterState = {
    ...currentFilterState,
    sellerId: params?.id || null,
  };

  useEffect(() => {
    if (isBookSeller) {
      const filter = {
        ...syncedFilterState,
        isBooks: true,
      };

      dispatch(setProductFilter(filter));
    }
  }, [isBookSeller]);
  const [selectedChildId, setSelectedChildId] = useState<
    string | null | number
  >(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [top100Banner, setTop100Banner] = useState(false);
  useEffect(() => {
    if (selectedCategoryId === 0) {
      setTop100Banner(true);
    } else {
      setTop100Banner(false);
    }
  }, [selectedCategoryId]);
  const user = useSelector((state: RootState) => state.user.user);
  const [lastSearch, setLastSearch] = useState<{
    value: string;
    type: "author" | "searchString" | "both" | null;
  }>({ value: "", type: null });
  const lastFallback = useRef<{ value: string; type: string } | null>(null);
  const products = useSelector((state: RootState) => state.seller.products);
  const sellerDataLoading = useSelector(
    (state: RootState) => state.seller.isLoading
  );
  const categories = useSelector(
    (state: RootState) => state.categories.categoryList
  );
  const booksCategory = categories.find(
    (cat: any) => cat.categoryName?.trim().toLowerCase() === "books"
  );
  const parentCategoryDetails = useSelector(
    (state: RootState) => state.seller.products?.parentCategoryDetails
  );
  const seller = useSelector((state: RootState) => state.seller.seller);
  const authors = useSelector((state: RootState) => state.authors.authors);
  const sellerBrand = useSelector(
    (state: RootState) => state.sellerShopFilter.sellerFilters.brand
  );
  const reviews = useSelector(
    (state: RootState) => state.rating.sellerReview.review
  );
  const reviewProducts = useSelector(
    (state: RootState) => state.rating.sellerReview.product
  );
  const wishlist = useSelector((state: RootState) => state.wishlist.wishList);
  const accessToken: any = useSelector(
    (state: RootState) => state.user.accessToken
  );
  const Seller_Shop_Name = seller?.shopName || seller?.firstName || "";
  const shareUrl = `${window.location.origin}/product-page/${
    shareProductDetails.id
  }/${titelize(shareProductDetails.title)}`;

  const handleCategoryClick = (event: any, currentIndx: any) => {
    setOpenDropdown((prev: any) => ({
      ...prev,
      [currentIndx]: !prev[currentIndx],
    }));
    setAnchorEl((prev: any) => ({
      ...prev,
      [currentIndx]: !!prev[currentIndx] ? null : event.target,
    }));
  };
  const handleClose = (index: any) => {
    setOpenDropdown((prev: any) => ({ ...prev, [index]: false }));
    setAnchorEl((prev: any) => ({
      ...prev,
      [index]: null,
    }));
  };
  // const changeCategoryName = (category?: number, categoryName?: string) => {
  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: params?.id,
  //       page,
  //       filter: {
  //         parentCategoryIdList: category,
  //         ...(!!categoryName && { searchString: categoryName }),
  //       },
  //     })
  //   );
  // };

  // const handleInternalTextSearch = (searchData: string) => {
  //   console.table(currentFilterState);
  //   console.log(searchField);
  //   const enteredValueByUser = (searchData || "").toLowerCase();
  //   // If input is all digits and exactly 13 characters, treat as ISBN

  //   // Remove parentCategoryIdList from filter and reset page to 1
  //   const updatedFilter = {
  //     ...syncedFilterState.filter,
  //     // author: enteredValueByUser,
  //   };

  //   //if title is selected
  //   if (searchField === "title") {
  //     updatedFilter.searchString = enteredValueByUser;
  //     delete updatedFilter?.author;
  //     delete updatedFilter.ISBN;
  //   } else if (searchField === "author") {
  //     updatedFilter.author = enteredValueByUser;
  //     delete updatedFilter?.ISBN;
  //     delete updatedFilter?.searchString;
  //   } else if (searchField === "isbn") {
  //     if (/^\d{13}$/.test(enteredValueByUser)) {
  //       updatedFilter.ISBN = enteredValueByUser;
  //       delete updatedFilter?.searchString;
  //       delete updatedFilter?.author;
  //     } else {
  //       alert("Enter a valid ISBN");
  //     }
  //   }
  //   //   if (/^\d{13}$/.test(enteredValueByUser)) {
  //   //     updatedFilter.ISBN = enteredValueByUser;

  //   //     // Optionally, you might want to remove 'author' if ISBN is set
  //   //     delete updatedFilter.searchString;
  //   //   } else {
  //   //     updatedFilter.searchString = enteredValueByUser;
  //   //     updatedFilter.author = enteredValueByUser;
  //   //     delete updatedFilter.ISBN;
  //   //   }
  //   delete updatedFilter.parentCategoryIdList;

  //   const updatedState = {
  //     sellerId: params?.id || null,
  //     page: 1,
  //     filter: updatedFilter,
  //   };

  //   dispatch(setProductFilter(updatedState));

  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: updatedState.sellerId,
  //       page: updatedState.page,
  //       filter: updatedFilter,
  //     })
  //   );
  // };

  // const handleInternalTextSearch = (searchData: string) => {
  //   const enteredValueByUser = (searchData || "").trim().toLowerCase();

  //   // Remove parentCategoryIdList from filter and reset page to 1
  //   const updatedFilter: any = {
  //     ...syncedFilterState.filter,
  //   };

  //   // Check for ISBN (13 digits)
  //   if (/^\d{13}$/.test(enteredValueByUser)) {
  //     updatedFilter.ISBN = enteredValueByUser;
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //   } else if (enteredValueByUser.length > 0) {
  //     // Optionally, you can check for author names from a known list
  //     // For now, let's assume if the input contains only letters and spaces, treat as author
  //     if (
  //       /^[a-z\s]+$/.test(enteredValueByUser) &&
  //       enteredValueByUser.split(" ").length > 1
  //     ) {
  //       updatedFilter.author = enteredValueByUser;
  //       delete updatedFilter.searchString;
  //       delete updatedFilter.ISBN;
  //     } else {
  //       // Default: treat as title search
  //       updatedFilter.searchString = enteredValueByUser;
  //       delete updatedFilter.author;
  //       delete updatedFilter.ISBN;
  //     }
  //   } else {
  //     // If input is empty, clear all search filters
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.ISBN;
  //   }

  //   delete updatedFilter.parentCategoryIdList;

  //   const updatedState = {
  //     sellerId: params?.id || null,
  //     page: 1,
  //     filter: updatedFilter,
  //   };

  //   dispatch(setProductFilter(updatedState));
  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: updatedState.sellerId,
  //       page: updatedState.page,
  //       filter: updatedFilter,
  //     })
  //   );
  // };

  // const handleInternalTextSearch = (searchData: string) => {
  //   const enteredValueByUser = (searchData || "").trim().toLowerCase();
  //   let updatedFilter: any = { ...syncedFilterState.filter };

  //   if (/^\d{13}$/.test(enteredValueByUser)) {
  //     updatedFilter.ISBN = enteredValueByUser;
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     setLastSearch({ value: "", type: null });
  //     lastFallback.current = null;
  //     return;
  //   }

  //   if (!enteredValueByUser) {
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     setLastSearch({ value: "", type: null });
  //     lastFallback.current = null;
  //     return;
  //   }

  //   // Try author first if input looks like an author
  //   if (
  //     /^[a-z\s]+$/.test(enteredValueByUser) &&
  //     enteredValueByUser.split(" ").length > 1
  //   ) {
  //     updatedFilter.author = enteredValueByUser;
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     setLastSearch({ value: enteredValueByUser, type: "author" });
  //     lastFallback.current = null;
  //     return;
  //   }

  //   // Otherwise, treat as title (searchString)
  //   updatedFilter.searchString = enteredValueByUser;
  //   delete updatedFilter.author;
  //   delete updatedFilter.ISBN;
  //   delete updatedFilter.parentCategoryIdList;
  //   dispatch(
  //     setProductFilter({
  //       sellerId: params?.id || null,
  //       page: 1,
  //       filter: updatedFilter,
  //     })
  //   );
  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: params?.id || null,
  //       page: 1,
  //       filter: updatedFilter,
  //     })
  //   );
  //   setLastSearch({ value: enteredValueByUser, type: "searchString" });
  //   lastFallback.current = null;
  // };
  // const handleInternalTextSearch = (searchData: string) => {
  //   const enteredValueByUser = (searchData || "").trim().toLowerCase();
  //   let updatedFilter: any = { ...syncedFilterState.filter };

  //   // ISBN check
  //   if (/^\d{13}$/.test(enteredValueByUser)) {
  //     updatedFilter.ISBN = enteredValueByUser;
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     setLastSearch({ value: "", type: null });
  //     lastFallback.current = null;
  //     return;
  //   }

  //   if (!enteredValueByUser) {
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     setLastSearch({ value: "", type: null });
  //     lastFallback.current = null;
  //     return;
  //   }
  //   console.log(authors.length, "authors length");
  //   // --- AUTHOR REGEX MATCH ---
  //   // Try to find a matching author using regex (case-insensitive, partial match)
  //   const authorMatch = authors.find((author: any) => {
  //     if (!author?.name) return false;
  //     // Use regex to check if enteredValueByUser is a substring of author.name (case-insensitive)
  //     return new RegExp(enteredValueByUser, "i").test(author.name);
  //   });

  //   if (authorMatch) {
  //     console.log("Author match found:", authorMatch.name);
  //     updatedFilter.author = enteredValueByUser;
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     setLastSearch({ value: authorMatch.name, type: "author" });
  //     lastFallback.current = null;
  //     return;
  //   }

  //   // Otherwise, treat as title (searchString)
  //   updatedFilter.searchString = enteredValueByUser;
  //   delete updatedFilter.author;
  //   delete updatedFilter.ISBN;
  //   delete updatedFilter.parentCategoryIdList;
  //   dispatch(
  //     setProductFilter({
  //       sellerId: params?.id || null,
  //       page: 1,
  //       filter: updatedFilter,
  //     })
  //   );
  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: params?.id || null,
  //       page: 1,
  //       filter: updatedFilter,
  //     })
  //   );
  //   setLastSearch({ value: enteredValueByUser, type: "searchString" });
  //   lastFallback.current = null;
  // };
  // const handleInternalTextSearch = (searchData: string) => {
  //   const enteredValueByUser = (searchData || "").trim().toLowerCase();
  //   let updatedFilter: any = { ...syncedFilterState.filter };

  //   // ISBN check
  //   if (/^\d{13}$/.test(enteredValueByUser)) {
  //     updatedFilter.ISBN = enteredValueByUser;
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     return;
  //   }

  //   // Empty input: clear filters
  //   if (!enteredValueByUser) {
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.author;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     return;
  //   }

  //   // Clean and split input into words
  //   const clean = (str: string) =>
  //     str.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "").toLowerCase();
  //   const enteredWords = enteredValueByUser
  //     .split(/\s+/)
  //     .map(clean)
  //     .filter(Boolean);

  //   // If more than 3 words, always search by title
  //   if (enteredWords.length > 3) {
  //     updatedFilter.searchString = enteredValueByUser;
  //     delete updatedFilter.author;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     return;
  //   }

  //   // Try to match author (any word, any order, case-insensitive)
  //   const authorMatch = authors.find((author: any) => {
  //     if (!author?.name) return false;
  //     const authorWords = author.name.split(/\s+/).map(clean).filter(Boolean);
  //     // Only match if EVERY entered word is present in authorWords
  //     return enteredWords.every((word) => authorWords.includes(word));
  //   });

  //   if (authorMatch) {
  //     updatedFilter.author = enteredValueByUser; // Use the matched author name
  //     delete updatedFilter.searchString;
  //     delete updatedFilter.ISBN;
  //     delete updatedFilter.parentCategoryIdList;
  //     dispatch(
  //       setProductFilter({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     dispatch(
  //       updateOnlyProductsStart({
  //         sellerId: params?.id || null,
  //         page: 1,
  //         filter: updatedFilter,
  //       })
  //     );
  //     return;
  //   }

  //   // No author match: search by title
  //   updatedFilter.searchString = enteredValueByUser;
  //   delete updatedFilter.author;
  //   delete updatedFilter.ISBN;
  //   delete updatedFilter.parentCategoryIdList;
  //   dispatch(
  //     setProductFilter({
  //       sellerId: params?.id || null,
  //       page: 1,
  //       filter: updatedFilter,
  //     })
  //   );
  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: params?.id || null,
  //       page: 1,
  //       filter: updatedFilter,
  //     })
  //   );
  // };
  const handleInternalTextSearch = (searchData: string) => {
    const enteredValueByUser = (searchData || "").trim().toLowerCase();
    let updatedFilter: any = { ...syncedFilterState.filter };

    // ISBN check
    if (/^\d{13}$/.test(enteredValueByUser)) {
      updatedFilter.ISBN = enteredValueByUser;
      delete updatedFilter.searchString;
      delete updatedFilter.author;
      delete updatedFilter.parentCategoryIdList;
      dispatch(
        setProductFilter({
          sellerId: params?.id || null,
          page: 1,
          filter: updatedFilter,
        })
      );
      dispatch(
        updateOnlyProductsStart({
          sellerId: params?.id || null,
          page: 1,
          filter: updatedFilter,
        })
      );
      setLastSearch({ value: "", type: null });
      lastFallback.current = null;
      return;
    }

    // Empty input: clear filters
    if (!enteredValueByUser) {
      delete updatedFilter.searchString;
      delete updatedFilter.author;
      delete updatedFilter.ISBN;
      delete updatedFilter.parentCategoryIdList;
      dispatch(
        setProductFilter({
          sellerId: params?.id || null,
          page: 1,
          filter: updatedFilter,
        })
      );
      dispatch(
        updateOnlyProductsStart({
          sellerId: params?.id || null,
          page: 1,
          filter: updatedFilter,
        })
      );
      setLastSearch({ value: "", type: null });
      lastFallback.current = null;
      return;
    }

    // Always search by title first
    updatedFilter.searchString = enteredValueByUser;
    delete updatedFilter.author;
    delete updatedFilter.ISBN;
    delete updatedFilter.parentCategoryIdList;
    dispatch(
      setProductFilter({
        sellerId: params?.id || null,
        page: 1,
        filter: updatedFilter,
      })
    );
    dispatch(
      updateOnlyProductsStart({
        sellerId: params?.id || null,
        page: 1,
        filter: updatedFilter,
      })
    );
    setLastSearch({ value: enteredValueByUser, type: "searchString" });
    lastFallback.current = null;
  };

  // Fallback effect: If no products and last search was searchString, try author
  useEffect(() => {
    if (
      lastSearch.value &&
      products.length === 0 &&
      lastSearch.type === "searchString"
    ) {
      // Prevent repeated fallback for the same value/type
      if (
        lastFallback.current &&
        lastFallback.current.value === lastSearch.value &&
        lastFallback.current.type === lastSearch.type
      ) {
        return;
      }
      let fallbackFilter: any = { ...syncedFilterState.filter };
      fallbackFilter.author = lastSearch.value;
      delete fallbackFilter.searchString;
      delete fallbackFilter.ISBN;
      delete fallbackFilter.parentCategoryIdList;

      dispatch(
        setProductFilter({
          sellerId: params?.id || null,
          page: 1,
          filter: fallbackFilter,
        })
      );
      dispatch(
        updateOnlyProductsStart({
          sellerId: params?.id || null,
          page: 1,
          filter: fallbackFilter,
        })
      );
      lastFallback.current = { value: lastSearch.value, type: lastSearch.type };
      setLastSearch({ value: "", type: null }); // Prevent infinite loop
    }
    // eslint-disable-next-line
  }, [products, lastSearch]);
  // Fallback effect: If no products and last search was author/title, try the other
  useEffect(() => {
    if (
      lastSearch.value &&
      products.length === 0 &&
      (lastSearch.type === "author" || lastSearch.type === "searchString")
    ) {
      // Prevent repeated fallback for the same value/type
      if (
        lastFallback.current &&
        lastFallback.current.value === lastSearch.value &&
        lastFallback.current.type === lastSearch.type
      ) {
        return;
      }
      let fallbackFilter: any = { ...syncedFilterState.filter };
      if (lastSearch.type === "author") {
        fallbackFilter.searchString = lastSearch.value;
        delete fallbackFilter.author;
      } else {
        fallbackFilter.author = lastSearch.value;
        delete fallbackFilter.searchString;
      }
      delete fallbackFilter.ISBN;
      delete fallbackFilter.parentCategoryIdList;

      dispatch(
        setProductFilter({
          sellerId: params?.id || null,
          page: 1,
          filter: fallbackFilter,
        })
      );
      dispatch(
        updateOnlyProductsStart({
          sellerId: params?.id || null,
          page: 1,
          filter: fallbackFilter,
        })
      );
      lastFallback.current = { value: lastSearch.value, type: lastSearch.type };
      setLastSearch({ value: "", type: null }); // Prevent infinite loop
    }
    // eslint-disable-next-line
  }, [products, lastSearch]);

  const changeCategoryName = (category?: number, categoryName?: string) => {
    // Case: Clear all filters if both category and categoryName are undefined
    if (category === undefined && categoryName === undefined) {
      const clearedState = {
        sellerId: params?.id || null,
        page: 1,
        filter: {
          searchString: null,
          categories: null,
          brand: null,
          parentCategoryIdList: null,
          author: null,
          ISBN: null,
        }, // Completely clear the filter
      };
      dispatch(setProductFilter(clearedState));
      // console.log("Inside cat and name undefined");
      // console.table(currentFilterState);
      dispatch(
        updateOnlyProductsStart({
          sellerId: clearedState.sellerId,
          page: clearedState.page,
        })
      );
      return;
    }

    const updatedFilter = {
      ...syncedFilterState.filter,
      parentCategoryIdList: category ?? null,
    };
    delete updatedFilter.searchString;
    delete updatedFilter.ISBN;
    delete updatedFilter.author;

    if (categoryName) {
      updatedFilter.searchString = categoryName;
    }

    const updatedState = {
      sellerId: params?.id || null,
      page: 1,
      filter: updatedFilter,
    };

    dispatch(setProductFilter(updatedState));
    dispatch(
      updateOnlyProductsStart({
        sellerId: updatedState.sellerId,
        page: updatedState.page,
        filter: updatedFilter,
      })
    );
  };

  // const handlePageChange = (newPage: number) => {
  //   const updatedState = {
  //     ...syncedFilterState,
  //     page: newPage,
  //   };

  //   dispatch(setProductFilter(updatedState));

  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: updatedState.sellerId,
  //       page: updatedState.page,
  //       filter: updatedState.filter,
  //     })
  //   );

  //   window.scrollTo(0, 0);
  // };

  // else if (updatedFilter.author) {
  //   // Author search, keep parentCategoryIdList if present
  //   updatedFilter = {
  //     author: updatedFilter.author,
  //     ...(updatedFilter.parentCategoryIdList && {
  //       parentCategoryIdList: updatedFilter.parentCategoryIdList,
  //     }),
  //   };
  // } else if (updatedFilter.searchString) {
  //   // Title search, keep parentCategoryIdList if present
  //   updatedFilter = {
  //     searchString: updatedFilter.searchString,
  //     ...(updatedFilter.parentCategoryIdList && {
  //       parentCategoryIdList: updatedFilter.parentCategoryIdList,
  //     }),
  //   };
  // }

  const handlePageChange = (newPage: number) => {
    let updatedFilter: any = { ...syncedFilterState.filter };

    if (updatedFilter.ISBN) {
      // Only ISBN search, ignore category
      updatedFilter = { ISBN: updatedFilter.ISBN };
    } else if (updatedFilter.searchString) {
      // Title search, keep parentCategoryIdList if present
      updatedFilter = {
        searchString: updatedFilter.searchString,
        ...(updatedFilter.parentCategoryIdList && {
          parentCategoryIdList: updatedFilter.parentCategoryIdList,
        }),
      };
    } else if (updatedFilter.author) {
      // Author search, keep parentCategoryIdList if present
      updatedFilter = {
        author: updatedFilter.author,
        ...(updatedFilter.parentCategoryIdList && {
          parentCategoryIdList: updatedFilter.parentCategoryIdList,
        }),
      };
    } else {
      // No search, keep all filters as is
      updatedFilter = { ...updatedFilter };
    }

    const updatedState = {
      ...syncedFilterState,
      page: newPage,
      filter: updatedFilter,
    };

    dispatch(setProductFilter(updatedState));
    dispatch(
      updateOnlyProductsStart({
        sellerId: updatedState.sellerId,
        page: updatedState.page,
        filter: updatedState.filter,
      })
    );

    window.scrollTo(0, 0);
  };
  const handleBookCategoryChange = (
    categoryId: string | null | number,
    categoryName: string
  ) => {
    setSelectedChildId(categoryId);
    changeCategoryName(Number(categoryId), categoryName); // Call your existing function
  };
  const renderSubCategories = (subCategories: any) => (
    <Grid
      container
      sx={{
        padding: "5px 10px",
      }}
    >
      <Grid item>
        {subCategories.map((subCategory: any, index: number) => {
          return (
            <Grid container key={subCategory.categoryId}>
              <Grid item>
                <Typography
                  variant="subtitle2"
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                  onClick={() => changeCategoryName(subCategory.categoryId)}
                >
                  {subCategory.categoryName}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );

  // const handleAddToWishList = (item: any) => {
  //   if (!accessToken) {
  //     snack.error("Please Sign in to Continue");
  //     return;
  //   } else {
  //     const _product: any = {};
  //     _product.productId = item._id;
  //     _product.name = item.title;
  //     _product.price = Number(
  //       item.saleprice ? item.saleprice[0] : item.price[0]
  //     );
  //     _product.type = "wishlist";
  //     _product.total = Number(
  //       item.saleprice ? item.saleprice[0] : item.price[0]
  //     );
  //     dispatch(addToWishListStart(_product));
  //     snack.success("Item added to Wishlist");
  //   }
  // };
  // const handleRemoveToWishList = (item: any) => {
  //   if (!wishlist) {
  //     return;
  //   }
  //   wishlist.map((wishlistItem) => {
  //     if (wishlistItem["_id"] === item._id) {
  //       dispatch(removeFromWishListStart(wishlistItem["wishlistId"]));
  //       snack.error("Item removed from Wishlist");
  //     }
  //   });
  // };

  // const handleInternalTextSearch = (searchData: string) => {
  //   const enteredValueByUser = (searchData || "").toLowerCase();
  //   dispatch(
  //     updateOnlyProductsStart({
  //       sellerId: params?.id,
  //       page,
  //       filter: {
  //         searchString: enteredValueByUser,
  //         categories: filteredData.categories,
  //       },
  //     })
  //   );
  // };
  // Get current product filter state from Redux

  const handleSmallScreenFiltersExpand =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setSmallScreenFilter(isExpanded ? panel : false);
    };

  const handleChange = (event: any, newValue: any) => {
    setTabValue(newValue);
  };

  const checkFollowStatus = async () => {
    if (!user._id || !seller?._id) {
      return;
    }
    try {
      console.log(
        "Checking follow status for userId:",
        user._id,
        "and sellerId:",
        seller._id
      );
      const followingList = await getFollowingStatus(user._id);
      console.log("Received followingList:", followingList);
      const isCurrentSellerFollowed = followingList.some(
        (followedSeller: any) => followedSeller.sellerId._id === seller._id
      );
      console.log("Is current seller followed:", isCurrentSellerFollowed);
      setIsFollowing(isCurrentSellerFollowed);
    } catch (error) {
      console.error("Error checking follow status:", error);
    }
  };

  const handleFollowClick = async () => {
    if (!user._id || !seller?._id) {
      return;
    }
    setIsLoading(true);
    try {
      if (isFollowing) {
        await unfollowSeller(user._id, seller._id);
        setIsFollowing(false);
      } else {
        await followSeller(user._id, seller._id);
        setIsFollowing(true);
      }
      localStorage.setItem(
        `followStatus_${user._id}_${seller._id}`,
        JSON.stringify(!isFollowing)
      );
    } catch (error: any) {
      console.error("Error updating follow status:", error);
      if (
        error.response?.data?.details ===
        "User is already following this seller"
      ) {
        setIsFollowing(true);
      } else {
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setId(location?.state?.item?._id);
  }, [location]);

  useEffect(() => {
    dispatch(getAuthorsStart());
  }, [dispatch]);

  useEffect(() => {
    if (params.id) {
      dispatch(getAuthorsStart());
      if (currentFilterState.filter?.searchString !== "Top_100") {
        dispatch(
          getProductsStart({
            sellerId: params?.id,
            page: syncedFilterState.page || 1,
            filter: { ...currentFilterState.filter },
          })
        );
      }
      dispatch(getReviewBySellerId(params?.id));
    }
  }, [params?.id]);

  useEffect(() => {
    let brands: any[] = [];
    sellerBrand.forEach((brand: any) => {
      brands.push(brand);
    });
    setSellerBrandData(brands);
  }, [sellerBrand]);

  useEffect(() => {
    if (user._id && seller?._id) {
      checkFollowStatus();
    }
  }, [user._id, seller]);

  useEffect(() => {
    if (selectedCategoryId || selectedCategoryId === null) {
      setSearchValue("");
    }
  }, [selectedCategoryId]);

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(location.search);
  //   const showTop100 = urlParams.get("top100");
  //   dispatch(getReviewBySellerId(params?.id));
  //   if (showTop100 === "true" && isBookSeller) {
  //     setSelectedCategoryId(0);
  //     handleBookCategoryChange(0, "Top_100");
  //   }
  // }, [location.search, isBookSeller]);
  useEffect(() => {

    // Check URL params first for top100
    const urlParams = new URLSearchParams(location.search);
    const showTop100 = urlParams.get("top100");

    if (showTop100 === "true" && isBookSeller) {
      setSelectedCategoryId(0);
      handleBookCategoryChange(0, "Top_100");
      return; // Exit early if handling top100
    }

    // Then check location state
    if (location?.state?.selectedCategoryId !== undefined) {
      const incomingCategoryId = location.state.selectedCategoryId;

      if (incomingCategoryId === 0 && isBookSeller) {
        setSelectedCategoryId(0);
        handleBookCategoryChange(0, "Top_100");
      } else if (incomingCategoryId === null) {
        setSelectedCategoryId(null);
        changeCategoryName();
      } else {
        setSelectedCategoryId(incomingCategoryId);
        changeCategoryName(incomingCategoryId);
      }
    }
  }, [location, isBookSeller]);

  return (
    <div className="shopDetailsContainer">
      <ShopMetaTags seller={seller} />
      <ShopBanner seller={seller} userId={user._id} top100={top100Banner} />

      <div className="row">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            marginTop: "10px",
          }}
          className="largeScreenFilters"
        >
          <div
            style={{
              width: "95%",
            }}
          >
            <Grid
              container
              // spacing={1}
              justifyContent={"space-between"}
              alignItems={"flex-start"}
            >
              <Grid item xs={8} sm={7}>
                <Grid container spacing={0.5}>
                  <Grid item>
                    {user._id && seller && seller.sellerId && (
                      <FollowButton
                        onClick={handleFollowClick}
                        isFollowed={isFollowing}
                        disabled={isLoading}
                      >
                        {isLoading
                          ? "Loading..."
                          : isFollowing
                          ? "Followed"
                          : "Follow"}
                      </FollowButton>
                    )}
                  </Grid>
                  <Grid item>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        cursor: "pointer",
                        backgroundColor:
                          selectedCategoryId === null
                            ? "#243040"
                            : "transparent",
                        color: selectedCategoryId === null ? "#fff" : "inherit",
                        borderRadius:
                          selectedCategoryId === null ? "4px" : undefined,
                        px: 1.5,
                        py: 0.2,
                        boxShadow:
                          selectedCategoryId === null
                            ? "3px 6px 6px rgba(0, 0, 0, 0.45)"
                            : "none",
                        "&:hover": {
                          // textDecoration: "underline",
                          borderRadius: "4px",
                          backgroundColor: "rgb(87, 85, 85)",
                          color: "#fff",
                        },
                      }}
                      onClick={() => {
                        setSelectedCategoryId(null);
                        changeCategoryName();
                      }}
                    >
                      Home
                    </Typography>
                  </Grid>
                  {isBookSeller ? (
                    <>
                      {isBookSeller && booksCategory?.childData?.length > 0 && (
                        <>
                          {booksCategory.childData
                            .slice(-20)
                            .map((child: any) => (
                              <Grid item key={child.categoryId}>
                                <Grid
                                  container
                                  direction={"row"}
                                  alignItems={"center"}
                                >
                                  <Grid item>
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        cursor: "pointer",
                                        backgroundColor:
                                          selectedCategoryId ===
                                          child.categoryId
                                            ? "#243040"
                                            : "transparent",
                                        color:
                                          selectedCategoryId ===
                                          child.categoryId
                                            ? "#fff"
                                            : "inherit",
                                        borderRadius:
                                          selectedCategoryId ===
                                          child.categoryId
                                            ? "4px"
                                            : undefined,
                                        px: 1.5,
                                        py: 0.2,
                                        boxShadow:
                                          selectedCategoryId ===
                                          child.categoryId
                                            ? "3px 6px 6px rgba(0, 0, 0, 0.45)"
                                            : "none",
                                        "&:hover": {
                                          // textDecoration: "underline",
                                          borderRadius: "4px",
                                          backgroundColor: "rgb(87, 85, 85)",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={() => {
                                        setSelectedCategoryId(child.categoryId);
                                        handleBookCategoryChange(
                                          child.categoryId,
                                          child.categoryName
                                        );
                                      }}
                                    >
                                      {child.categoryName}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            ))}
                        </>
                      )}
                      {isBookSeller && (
                        <Button
                          onClick={() => {
                            setSelectedCategoryId(0);
                            handleBookCategoryChange(0, "Top_100");
                          }}
                          sx={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedCategoryId === 0
                                ? "#243040"
                                : "transparent",
                            color:
                              selectedCategoryId === 0 ? "#fff" : "inherit",
                            borderRadius:
                              selectedCategoryId === 0 ? "4px" : undefined,
                            px: 1.5,
                            py: 0.2,
                            boxShadow:
                              selectedCategoryId === 0
                                ? "3px 6px 6px rgba(0, 0, 0, 0.45)"
                                : "none",
                            "&:hover": {
                              // textDecoration: "underline",
                              borderRadius: "4px",
                              backgroundColor: "rgb(87, 85, 85)",
                              color: "#fff",
                            },
                          }}
                        >
                          Top 100
                        </Button>
                      )}
                    </>
                  ) : (
                    <>
                      {checkIsValidArray(parentCategoryDetails)
                        ? parentCategoryDetails.map(
                            (category: any, index: number) => (
                              <Grid item key={category.categoryId}>
                                <Grid
                                  container
                                  direction={"row"}
                                  alignItems={"center"}
                                >
                                  <Grid item>
                                    <Typography
                                      variant="subtitle2"
                                      sx={{
                                        cursor: "pointer",
                                        backgroundColor:
                                          selectedCategoryId ===
                                          category.categoryId
                                            ? "#243040"
                                            : "transparent",
                                        color:
                                          selectedCategoryId ===
                                          category.categoryId
                                            ? "#fff"
                                            : "inherit",
                                        borderRadius:
                                          selectedCategoryId ===
                                          category.categoryId
                                            ? "4px"
                                            : undefined,
                                        px: 1.5,
                                        py: 0.2,
                                        my: 0,
                                        boxShadow:
                                          selectedCategoryId ===
                                          category.categoryId
                                            ? "3px 6px 6px rgba(0, 0, 0, 0.45)"
                                            : "none",
                                        "&:hover": {
                                          // textDecoration: "underline",
                                          borderRadius: "4px",
                                          backgroundColor: "rgb(87, 85, 85)",
                                          color: "#fff",
                                        },
                                      }}
                                      onClick={() =>
                                        changeCategoryName(category.categoryId)
                                      }
                                    >
                                      {category.categoryName}
                                    </Typography>
                                  </Grid>
                                  <Grid
                                    item
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {category.subCategories &&
                                      category.subCategories.length > 0 && (
                                        <ExpandMoreIcon
                                          onClick={(e) =>
                                            handleCategoryClick(e, index)
                                          }
                                          sx={{
                                            cursor: "pointer",
                                          }}
                                        />
                                      )}
                                    <Popper
                                      open={openDropdown?.[index]}
                                      anchorEl={anchorEl?.[index]}
                                      placement="bottom"
                                    >
                                      <ClickAwayListener
                                        onClickAway={() => handleClose(index)}
                                      >
                                        <Paper>
                                          {renderSubCategories(
                                            category.subCategories
                                          )}
                                        </Paper>
                                      </ClickAwayListener>
                                    </Popper>
                                  </Grid>
                                </Grid>
                              </Grid>
                            )
                          )
                        : null}
                    </>
                  )}
                </Grid>
              </Grid>

              <Grid item className="ShopFilter-Grid" xs={3} sm={4}>
                <TextField
                  fullWidth
                  value={searchValue}
                  sx={{
                    boxShadow: "0 2px 8px rgba(36, 48, 64, 0.15)", // subtle shadow
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                  }}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                      height: "40px",
                    },
                    startAdornment: (
                      <Search
                        style={{
                          opacity: 0.5,
                        }}
                      />
                    ),
                  }}
                  // onChange={(e: any) => {
                  //   setSearchValue(e.target.value);
                  // }}
                  // onKeyPress={(event: any) => {
                  //   if (event.key == "Enter") {
                  //     handleInternalTextSearch(searchValue);
                  //   }
                  // }}
                  onChange={(e: any) => {
                    setSearchValue(e.target.value);
                  }}
                  onKeyDown={(event: any) => {
                    // Trigger search on space or Enter
                    if (event.key === " " || event.key === "Enter") {
                      handleInternalTextSearch(event.target.value.trim());
                    }
                  }}
                  placeholder={`Search by title, author, or ISBN`}
                />
              </Grid>

              {/* <Grid item className="ShopFilter-Grid" xs={12} sm={5}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "40px",
                    borderRadius: "10px",
                    overflow: "hidden",
                    border: "1px solid #ccc",
                  }}
                >
                  {/* Text Input (70%) */}
              {/*<TextField
                    variant="standard"
                    fullWidth
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    onKeyPress={(event) => {
                      if (event.key === "Enter") {
                        handleInternalTextSearch(searchValue);
                      }
                    }}
                    placeholder={`Search by ${searchField || "title"}...`}
                    InputProps={{
                      disableUnderline: true,
                      startAdornment: (
                        <Search
                          style={{
                            opacity: 0.5,
                            marginRight: 8,
                            marginLeft: 8,
                          }}
                        />
                      ),
                      sx: {
                        paddingLeft: 1,
                        flex: 7,
                        height: "40px",
                        borderRight: "1px solid #ccc",
                      },
                    }}
                  />

                  {/* Toggle Buttons (30%) */}
              {/*<ToggleButtonGroup
                    value={searchField}
                    exclusive
                    onChange={(e, newField) => {
                      if (newField) setSearchField(newField);
                    }}
                    size="small"
                    sx={{
                      display: "flex",
                      flex: 3,
                      height: "40px",
                      ".MuiToggleButton-root": {
                        flex: 1,
                        textTransform: "none",
                        fontSize: "12px",
                        fontWeight: "bold",
                        borderRadius: 0,
                        border: "none",
                        height: "100%",
                      },
                      ".Mui-selected": {
                        backgroundColor: "#243040 !important",
                        color: "#fff !important",
                      },
                      ".MuiToggleButton-root:not(.Mui-selected)": {
                        backgroundColor: "#fff",
                        color: "#000",
                        borderLeft: "1px solid rgba(0,0,0,0.1)",
                        ":hover": {
                          backgroundColor: "#f0f0f0",
                        },
                      },
                    }}
                  >
                    <ToggleButton value="title">Title</ToggleButton>
                    <ToggleButton value="author">Author</ToggleButton>
                    <ToggleButton value="isbn">ISBN</ToggleButton>
                  </ToggleButtonGroup>
                </Box>
              </Grid> */}
            </Grid>
          </div>
        </div>
        {/* Mobile View Filters */}
        <Drawer
          anchor={"bottom"}
          open={filter}
          onClose={() => setfilter(!filter)}
          className="drawer"
        >
          <MobileViewFilterWrapper>
            <FilterContainer>
              <FilterLabel>FILTERS</FilterLabel>
              <ClearButton onClick={() => setfilter(!filter)}>X</ClearButton>
            </FilterContainer>
            <div>
              <Accordion
                expanded={smallScreenFilter === "Categories"}
                onChange={handleSmallScreenFiltersExpand("Categories")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="Categories-content"
                  id="Categories-header"
                >
                  <p className="sellerHeaders">Categories</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="contentOverFlow">
                    <FormGroup>
                      <Box display="flex" flexDirection="column" gap={1}>
                        {/* Add Top 100 button for mobile view */}
                        {isBookSeller && (
                          <Box
                            onClick={() => {
                              setSelectedCategoryId(null);
                              handleBookCategoryChange(null, "Top_100");
                              setfilter(false); // Close the mobile filter drawer
                            }}
                            sx={{
                              padding: "8px 16px",
                              borderRadius: "6px",
                              fontSize: "14px",
                              cursor: "pointer",
                              backgroundColor: "#1976d2",
                              color: "#fff",
                              border: "1px solid #1976d2",
                              textAlign: "center",
                              fontWeight: "600",
                              marginBottom: "8px",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                          >
                            Top 100
                          </Box>
                        )}
                        {isBookSeller &&
                          (() => {
                            const list =
                              booksCategory?.childData?.slice(-25).reverse() ||
                              [];
                            const sortedList = selectedChildId
                              ? [
                                  ...list.filter(
                                    (item: any) =>
                                      item.categoryId === selectedChildId
                                  ),
                                  ...list.filter(
                                    (item: any) =>
                                      item.categoryId !== selectedChildId
                                  ),
                                ]
                              : list;

                            return sortedList.map((child: any) => (
                              <Box
                                key={child.categoryId}
                                onClick={() => {
                                  if (child.categoryId === selectedChildId) {
                                    setSelectedChildId(null);
                                    changeCategoryName(); // Home
                                  } else {
                                    setSelectedChildId(child.categoryId);
                                    changeCategoryName(
                                      Number(child.categoryId),
                                      child.categoryName
                                    );
                                  }
                                  setfilter(false);
                                }}
                                sx={{
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  cursor: "pointer",
                                  backgroundColor:
                                    selectedChildId === child.categoryId
                                      ? "#e0f2f1"
                                      : "#fff",
                                  color:
                                    selectedChildId === child.categoryId
                                      ? "#00796b"
                                      : "#000",
                                  border:
                                    selectedChildId === child.categoryId
                                      ? "1px solid #00796b"
                                      : "1px solid #ccc",
                                  "&:hover": {
                                    backgroundColor: "#f5f5f5",
                                  },
                                }}
                              >
                                {child.categoryName}
                              </Box>
                            ));
                          })()}
                      </Box>
                    </FormGroup>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={smallScreenFilter === "Brand"}
                onChange={handleSmallScreenFiltersExpand("Brand")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="Brand-content"
                  id="Brand-header"
                >
                  <p className="sellerHeaders">Brand</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="contentOverFlow">
                    <FormGroup>
                      {sellerBrandData.map((item: any, index: number) => (
                        <FormControlLabel
                          key={index.toString()}
                          control={
                            <Checkbox
                              defaultChecked={
                                filteredData.brand.indexOf(item) >= 0
                                  ? true
                                  : false
                              }
                              onChange={(e: any, checked: any) => {
                                let data = [...sellerBrandData];
                                let data1 = [...filteredData.brand];
                                data.forEach((ele: any, index: number) => {
                                  if (item === ele) {
                                    // updating filter in filterData
                                    if (checked) {
                                      data1.push(item);
                                    } else {
                                      let i = data1.indexOf(item);
                                      data1.splice(i, 1);
                                    }
                                  }
                                });
                                setFilteredData({
                                  categories: filteredData.categories,
                                  brand: data1,
                                });
                                dispatch(
                                  updateOnlyProductsStart({
                                    sellerId: params?.id,
                                    page,
                                    filter: {
                                      categories: filteredData.categories,
                                      brand: data1,
                                    },
                                  })
                                );
                              }}
                            />
                          }
                          label={item}
                        />
                      ))}
                    </FormGroup>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            <br />
            <br />
          </MobileViewFilterWrapper>
        </Drawer>
        <p className="shops_filterButton" onClick={() => setfilter(true)}>
          FILTER
          <FontAwesomeIcon icon={faFilter} />
        </p>
        {/* Shop Details */}
        <div className={"col-lg-12 col-md-12 ShopDetailsWrapper"}>
          <div className={"shopDetailsContent"}>
            <Box sx={{ width: "100%", typography: "body1" }}>
              {/* 
              <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList onChange={handleChange}>
                    <Tab label="Shop" value="1" />
                    <Tab label="Reviews" value="3" />
                  </TabList>
                </Box>
                <TabPanel
                  value="1"
                  classes={{
                    root: "tabPanelRoot",
                  }}
                >
                  <> */}

              {checkIsValidArray(products.products) ? (
                <div className="row" style={{ marginBottom: "24px" }}>
                  {products.products.map((item: any, index: number) => (
                    <SingleProductLayout
                      key={index}
                      item={item}
                      params={params}
                      index={index}
                    />
                  ))}
                </div>
              ) : (
                <>
                  {!sellerDataLoading && (
                    <div style={{ textAlign: "center" }}>
                      <h4>
                        Product you searched for is not available in this shop.
                        Try searching in the main search bar above
                      </h4>
                    </div>
                  )}
                </>
              )}
              <div>
                <Pagination
                  page={currentFilterState.page}
                  count={products.totalPages}
                  onChange={(e, page) => handlePageChange(page)}
                  siblingCount={1} // Number of pages to show on each side of the current page
                  boundaryCount={2} // Number of pages to show at the start and end of pagination
                />
              </div>
              <Modal
                open={shareModelOpen}
                onClose={() => {
                  setShareModelOpen(false);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "white",
                    borderRadius: "5px",
                    boxShadow: "24",
                    p: 4,
                    height: 240,
                    background: "white",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h3"
                  >
                    Share this listing
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      padding: "0.4rem",
                      alignSelf: "stretch",
                    }}
                  >
                    <p>Click on this icon to copy below link</p>
                    <CopyToClipboard
                      text={`${window.location.origin}/product-page/${
                        shareProductDetails.id
                      }/${titelize(shareProductDetails.title)}`}
                      onCopy={() => {
                        snack.success("Link copied to clipboard!");
                      }}
                    >
                      <Tooltip
                        title="Copy Below link"
                        style={{ marginRight: "5em" }}
                      >
                        <InsertLinkIcon
                          sx={{
                            opacity: 1,
                            cursor: "pointer",
                            transition: "1s",
                            stroke: "black",
                            strokeWidth: 1,
                            "&:hover": {
                              opacity: 1,
                              transform: "scale(1.05)",
                              transition: "1s",
                            },
                          }}
                        />
                      </Tooltip>
                    </CopyToClipboard>
                  </Box>
                  <Box
                    sx={{
                      width: 500,
                      maxWidth: "100%",
                    }}
                  >
                    <CopyToClipboard
                      text={`${window.location.origin}/product-page/${
                        shareProductDetails.id
                      }/${titelize(shareProductDetails.title)}`}
                      onCopy={() => {
                        snack.success("Link copied to clipboard!");
                      }}
                    >
                      <TextField
                        fullWidth
                        label="Link"
                        sx={{ input: { cursor: "pointer" } }}
                        InputProps={{
                          style: {
                            borderRadius: "10px",
                          },
                        }}
                        disabled={true}
                        defaultValue={shareUrl}
                      />
                    </CopyToClipboard>
                  </Box>
                  <div
                    style={{
                      background: "#0000",
                      height: "100vh",
                      width: "100%",
                      display: "flex",
                      gap: "0.5em",
                      justifyContent: "center",
                      marginTop: "1em",
                    }}
                  >
                    <FacebookShareButton url={shareUrl}>
                      <FacebookIcon size={40} round={true} />
                    </FacebookShareButton>

                    <WhatsappShareButton url={shareUrl}>
                      <WhatsappIcon size={40} round={true} />
                    </WhatsappShareButton>

                    <EmailShareButton url={shareUrl}>
                      <EmailIcon size={40} round={true} />
                    </EmailShareButton>

                    <RedditShareButton url={shareUrl}>
                      <RedditIcon size={40} round={true} />
                    </RedditShareButton>
                    <TwitterShareButton url={shareUrl}>
                      <TwitterIcon size={40} round={true} />
                    </TwitterShareButton>
                    <LinkedinShareButton url={shareUrl}>
                      <LinkedinIcon size={40} round={true} />
                    </LinkedinShareButton>
                  </div>
                </Box>
              </Modal>
              {/* </>
                </TabPanel>
                <TabPanel value="3">
                  {reviews?.length > 0 ? (
                    <>
                      <CustomReviewSection
                        reviews={reviews}
                        product={reviewProducts}
                      />
                    </>
                  ) : null}
                </TabPanel>
              </TabContext>
             */}
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopDetails;
